import { render, staticRenderFns } from "./DealTariffSummary.vue?vue&type=template&id=67e2d0dc&scoped=true&"
import script from "./DealTariffSummary.vue?vue&type=script&lang=js&"
export * from "./DealTariffSummary.vue?vue&type=script&lang=js&"
import style0 from "./DealTariffSummary.vue?vue&type=style&index=0&id=67e2d0dc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e2d0dc",
  null
  
)

export default component.exports